module.exports = __webpack_public_path__ + "img/depositphotos_218643838-stock-photo-delicious-carbonara-pasta-frying-pan.d9da2282.jpg";